/* eslint sort-keys: "error" */
export default {
    AccountConnection: {
        AccountOff: 'account-toggle-off',
        AccountOn: 'account-toggle-on',
        HideDetails: 'how-to-reconnect-hide-details',
        IncomeField: 'annual-pretax-income-field',
        LinkingArticle: 'blue-box-privacy-center',
        ShowDetails: 'how-to-reconnect-show-details',
        TC: 'data-connection-terms&condition'
    },
    Back: 'back-cta',
    Banner: {
        AccountSyncError: 'banner-account-sync-error',
        PlaidReconnect: 'plaid-disconnect-banner-reconnect-now',
        ReviewTransactions: 'banner-review-transactions',
        budgetExceedingTargetCancel: 'banner-budget-exceeding-target-cancel'
    },
    Bottom: {
        Back: 'bottom-main-page-back-cta',
        Cancel: 'bottom-main-page-cancel-cta',
        Confirm: 'confirm-button-cta-bottom',
        Next: 'next-button-cta-bottom',
        Save: 'bottom-main-page-save-cta'
    },
    Callout: {
        LinkAccounts: 'link-accounts-cta',
        SeeTransactions: 'does-this-number-look-off-see-transactions-cta'
    },
    CategoryBreakdown: {
        CategorySelect: 'category-breakdown-category-select',
        Close: 'category-breakdown-close',
        Expand: 'category-breakdown-expand',
        Modal: {
            Close: 'category-breakdown-modal-close',
            Graph: {
                Hover: 'category-breakdown-modal-graph-hover',
                SelectMonth: 'category-breakdown-modal-graph-select-month'
            },
            Tooltip: 'category-breakdown-modal-tooltip-avg-monthly-expense-info',
            ViewTransaction: 'category-breakdown-modal-view-transactions'
        }
    },
    CurrentMonth: {
        AddAccount: 'link-and-manage-accounts-cta',
        CreateBudget: 'create-category-budget-top',
        CreateBudgetBottom: 'create-category-budget-bottom',
        EachCategory: 'budget-tracker-each-category',
        Edit: 'edit-category-budget-top',
        EditBottom: 'edit-category-budget-bottom',
        ExpandableText: {
            HideDetails: 'does-this-number-look-off-hide-details',
            ShowDetails: 'does-this-number-look-off-show-details'
        },
        LineGraph: 'line-graph-hover',
        SetTargetModal: {
            Cancel: 'set-target-modal-cancel',
            Confirm: 'set-target-modal-confirm',
            Delete: 'set-target-modal-delete',
            TargetAmount: 'set-target-modal-target-amount',
            Tooltip: 'set-target-modal-tooltip-avg-monthly-expense-info',
            ViewTransactions: 'set-target-modal-view-transactions'
        },
        Spend: 'spent-cta',
        TargetStatsBoxEdit: 'target-statsbox-edit',
        TotalMonthlySpending: 'total-monthly-spending',
        ViewHistoryIcon: 'view-history-icon-cta',
        ViewTransaction: 'view-transaction-icon-cta'
    },
    Dropdown: {
        Category: 'change-category-dropdown-values',
        Frequency: 'change-frequency-dropdown-values',
        Rule: {
            Category: 'create-rule-category-dropdown-values',
            Contains: 'create-rule-contains-dropdown-values'
        }
    },
    Eligibility: 'eligibility-amex-card-link',
    EmailPreferences: 'toggle-email-preferences-button',
    Error: {
        Reconnect: 'account-error-reconnect',
        Subcategory: 'error-state-subcat-amount-greater-than-category-total',
        UnableToUpdate: 'account-error-unable-to-update-retry'
    },
    ErrorPage: {
        AmericanExpressHomepage: 'homepage-cta',
        Back: 'back-button-cta'
    },
    Filter: {
        Clear: 'empty-state-clear-filter',
        Icon: 'filter-icon',
        Remove: 'filter-remove-selection',
        Select: 'filter-select-'
    },
    Footer: 'terms&conditions-footer-cta',
    General: {
        NAccounts: 'n-accounts-cta',
        SetTarget: 'set-target-cta',
        ViewTransactionIcon: 'view-transaction-icon-cta',
        ViewTransactions: 'view-transactions-cta'
    },
    History: {
        Chart: {
            ViewTransaction: 'budget-history-chart-month-transaction-link'
        },
        ExpandableText: {
            HideDetails: 'how-is-this-calculated-hide-details',
            ShowDetails: 'how-is-this-calculated-show-details'
        },
        HistoryGraph: {
            Hover: 'history-graph-hover',
            SelectMonth: 'history-graph-select-month'
        },
        Month: {
            LeftHandSide: 'budget-history-select-month-left-hand-side',
            UpperTimelines: 'budget-history-select-month-upper-timelines'
        }
    },
    Ineligible: {
        AmexCards: 'american-express-card-link',
        EmailOnFile: 'email-on-file-cta'
    },
    Page: {
        Error: 'error',
        History: 'budget-history',
        Home: 'spendsmart-home',
        Ineligible: 'ineligible',
        Personalize: 'budget-categories',
        ReviewTransactions: 'review-transactions',
        Settings: 'budget-settings',
        Transactions: 'transactions',
        TransactionsDetails: 'transactions-details',
        TransactionsRules: 'transactions-rules'
    },
    Personalize: {
        Cancel: 'cancel-button-cta-bottom',
        Category: {
            Add: 'add-category-cta',
            AmountFill: 'each-category-amount-fill',
            Delete: 'delete-category-cta',
            Dropdown: 'select-category-dropdown-values'
        },
        Confirm: 'confirm-button-cta-bottom',
        Modal: 'view-category-history-modal',
        Subcategory: {
            Add: 'add-subcategory-cta',
            AmountFill: 'each-subcategory-amount-fill',
            Delete: 'delete-subcategory-cta',
            Dropdown: 'select-subcategory-dropdown-values'
        }
    },
    Plaid: {
        Agree: 'agree-and-link-account-plaid-button'
    },
    Reconnect: {
        DataConnectionTerms: 'how-to-reconnect-data-connection-terms&conditions',
        PrivacyCenter: 'how-to-reconnect-privacy-center',
        TC: 'how-to-reconnect-terms&condition'
    },
    RuleInfoModal: {
        Close: 'rule-info-modal-close',
        Open: 'rule-info-modal-open'
    },
    Rules: {
        Check: 'manage-rules-check-icon',
        Create: 'manage-rules-create-rule',
        Delete: 'manage-rules-trash-icon',
        Drag: 'manage-rules-adjust-rule-priority-drag',
        ExpenseTab: 'expense-rules-tab',
        IncomeTab: 'income-rules-tab'
    },
    Search: {
        Apply: 'search-transactions-search-cta',
        Clear: 'empty-state-clear-search',
        FieldFill: 'search-transactions-field-fill'
    },
    SecondaryNav: {
        Faqs: 'secondary-nav-faqs',
        Settings: 'secondary-nav-settings',
        Spendsmart: 'secondary-nav-spendsmart',
        Transactions: 'secondary-nav-transactions'
    },
    Settings: {
        AlertEmailToggleOff: 'budget-settings-alert-email-toggle-off',
        AlertEmailToggleOn: 'budget-settings-alert-email-toggle-on',
        MonthlyEmailToggleOff: 'budget-settings-monthly-email-toggle-off',
        MonthlyEmailToggleOn: 'budget-settings-monthly-email-toggle-on',
        UpdateEmail: 'budget-settings-update-email-cta'
    },
    TertiaryNav: {
        Current: 'tertiary-nav-current-month',
        History: 'tertiary-nav-history'
    },
    Tooltip: {
        AverageSpending: 'tooltip-your-avg-monthly-spending',
        BudgetStatsBox: {
            Budget: 'budget-statsbox-tooltip-budget-for-tracked-categories',
            LeftOver: 'budget-statsbox-tooltip-left-over',
            TotalSpent: 'budget-statsbox-tooltip-total-spent-in-categories'
        },
        Category: 'tooltip-category-monthly-avg-info',
        Frequency: 'tooltip-frequency',
        LinkAccounts: 'tooltip-link-your-other-financial-accounts',
        LinkAccountsArticle: 'tooltip-linking-account-article',
        MonthlySpending: 'set-total-monthly-spending-your-monthly-avg-tooltip',
        Subcategory: 'tooltip-subcategory-monthly-avg-info',
        TargetStatsBox: {
            LeftOver: 'target-statsbox-tooltip-left-over',
            Target: 'target-statsbox-tooltip-target-monthly-spending-amount',
            TotalSpent: 'target-statsbox-tooltip-total-spent'
        }
    },
    TotalAverageInfoModal: {
        Close: 'total-average-info-modal-close',
        OpenSpendingTotal: 'total-average-info-modal-open-spending-total',
        OpenTotalAverage: 'total-average-info-modal-open-total-average'
    },
    Transactions: {
        Bulk: {
            Approve: 'bulk-approve-banner-approve',
            Cancel: 'bulk-update-banner-delete-cta',
            Category: 'bulk-update-banner-change-category',
            Frequency: 'bulk-update-banner-change-frequency',
            Source: 'bulk-update-banner-change-source'
        },
        ChangeCategoryModal: {
            Cancel: 'change-category-modal-cancel-cta',
            Check: 'change-category-modal-create-rule-check',
            Dropdown: 'change-category-modal-dropdown-values',
            Uncheck: 'change-category-modal-create-rule-uncheck',
            Yes: 'change-category-modal-yes-cta'
        },
        ChangeFrequencyModal: {
            Cancel: 'change-freq-modal-cancel-cta',
            Dropdown: 'change-freq-modal-dropdown-values',
            Yes: 'change-freq-modal-yes-cta'
        },
        ChangeSourceModal: {
            Cancel: 'change-source-modal-cancel-cta',
            Check: 'change-source-modal-create-rule-check',
            Uncheck: 'change-source-modal-create-rule-uncheck',
            Yes: 'change-source-modal-yes-cta'
        },
        CheckAll: 'select-all-check-cta',
        DateRangeModal: {
            Apply: 'custom-date-modal-apply-cta',
            Cancel: 'custom-date-modal-cancel-cta'
        },
        Details: {
            Apply: 'manage-rule-apply-cta',
            Back: 'back-button',
            CancelName: 'nickname-edit-cancel-cta',
            Create: 'create-rule-button',
            EditName: 'nickname-edit-icon',
            SaveName: 'nickname-edit-save'
        },
        IncomeModal: {
            Apply: 'add-income-source-modal-apply-cta',
            Cancel: 'add-income-source-modal-cancel-cta',
            Name: 'add-income-source-modal-name-field'
        },
        ManageRules: 'manage-rules-cta',
        Pagination: {
            Next: 'pagination-next-page',
            Number: 'pagination-page-number',
            Previous: 'pagination-previous-page'
        },
        ReviewComplete: 'complete-view-all-transactions',
        Row: {
            Approve: 'transaction-row-approve-icon',
            CategoryDropdown: 'transaction-row-change-category-dropdown-values',
            CustomIncome: 'transaction-row-add-income-source-cta',
            CustomSubcategory: 'transaction-row-add-custom-subcategory-cta',
            Edit: 'transaction-row-edit-icon',
            FrequencyDropdown: 'transaction-row-change-frequency-dropdown-values',
            Select: 'transaction-row-select',
            Unselect: 'transaction-row-unselect',
            ViewDetails: 'transaction-row-view-transaction-details'
        },
        ShowHiddenOff: 'show-hidden-switch-off',
        ShowHiddenOn: 'show-hidden-switch-on',
        SortBy: 'sort-by-',
        SubcategoryModal: {
            Apply: 'add-custom-subcategory-modal-apply-cta',
            Cancel: 'add-custom-subcategory-modal-cancel-cta',
            Name: 'add-custom-subcategory-modal-name-field'
        },
        UncheckAll: 'select-all-uncheck-cta'
    },
    Unenroll: {
        Button: 'unenroll-button',
        Cancel: 'unenroll-cancel',
        Confirm: 'unenroll-confirm',
        DataConnectionTerms: 'unenroll-data-connection-terms&conditions',
        PrivacyCenter: 'unenroll-privacy-center',
        TC: 'unenroll-terms&conditions'
    },
    Walkme: {
        IntroModal: {
            CloseTourAction: 'close-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'take-tour-select',
            SkipTourAction: 'skip-tour-select',
            WidgetName: 'walk-me-tour-modal'
        },
        Popup1: {
            CloseTourAction: 'close-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'continue-tour-select',
            WidgetName: 'walk-me-tour-total-spend'
        },
        Popup2: {
            CloseTourAction: 'close-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'continue-tour-select',
            WidgetName: 'walk-me-tour-category-spend'
        },
        Popup3: {
            CloseTourAction: 'close-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'continue-tour-select',
            WidgetName: 'walk-me-tour-transfer-type'
        },
        Popup4: {
            CloseTourAction: 'close-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'continue-tour-select',
            WidgetName: 'walk-me-tour-recategorise-transaction'
        },
        Popup5: {
            CloseTourAction: 'end-tour-close',
            ImpressionAction: 'load-tour-view',
            NextTourAction: 'back-to-dashboard-select',
            WidgetName: 'walk-me-tour-transaction-rules'
        }
    },
    WelcomeSlider: {
        Slide1: {
            Close: 'welcome-slider-one-close',
            Next: 'welcome-slider-one-next'
        },
        Slide2: {
            Close: 'welcome-slider-two-close',
            Next: 'welcome-slider-two-next'
        },
        Slide3: {
            Close: 'welcome-slider-three-close',
            Next: 'welcome-slider-three-next'
        },
        Slide4: {
            Close: 'welcome-slider-four-close',
            Next: 'welcome-slider-four-next'
        }
    }
};
